import { Tag } from "antd";
import React, { Component } from "react";
import { TOOrderDetailsWrapper } from "./TOOrderDetails.styled";
import moment from "moment";
import { fetchDestinationName } from "../../helper/topickerhelper";

export class TOOrderDetails extends Component {
  state = {
    showScannerScreen: false,
  };

  numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  labelValue = (label, value, amt) => {
    let isNum = typeof value === "number" ? true : false;

    return (
      <>
        <label>{label} </label>
        <p>
          {value
            ? amt
              ? `₹ ${this.numberWithCommas(value)}`
              : isNum
              ? this.numberWithCommas(value)
              : value
            : "-"}
        </p>
      </>
    );
  };

  render() {
    const { toData, boxNumber, isChecker } = this.props;
    return (
      <TOOrderDetailsWrapper>
        <div className="orderIdWrapper">
          {this.labelValue(
            "Transfer Order No:",
            isChecker ? toData?.toNumber : toData?.transferOrderNumber
          )}

          {boxNumber && (
            <div style={{ flexGrow: 1 }}>
              <Tag color="volcano" className="boxSection">
                BOX#{boxNumber}
              </Tag>
            </div>
          )}
        </div>

        {this.labelValue(
          "Destination :",
          fetchDestinationName(
            isChecker ? toData?.destinationWarehouseId : toData?.destination,
            this.props.warehouseList
          )
        )}
        {this.labelValue("SKU Count :", toData?.skuCount)}
        {this.labelValue(
          "Quantity :",
          isChecker ? toData?.pickedQuantity : toData?.quantity
        )}
        {this.labelValue(
          "TO Created Date :",
          toData?.toCreatedOn
            ? moment(toData?.toCreatedOn).format("DD/MM/YYYY hh:mm a")
            : "-"
        )}
        {this.labelValue("Order Value :", Math.round(toData?.orderValue), true)}
        {this.labelValue("Picker Name :", toData?.pickerName)}
      </TOOrderDetailsWrapper>
    );
  }
}

export default TOOrderDetails;
